import React from 'react';
import c from 'classnames';
import { Item } from '../item';
import styles from './ItemsList.css';
import { useCurrentBreakPoint } from '../commons';
import { adBreakPoint } from '../../lib/helpers';
import { Ads, createSlotParams } from '../ads';

const AdWrapper = ({ children, fullWidth }) => {
  return (
    <>
      {fullWidth && <div className='full full-ad-block'>{children}</div>}
      {!fullWidth && children}
    </>
  );
};

export const ItemsList = ({
  items,
  isToppers,
  isSidebar,
  isStoreItem,
  hideAds,
  pages = {},
  typeOfList,
  isModalRelatedItem,
}) => {
  let adCounter = 0;
  const counterIncrement = () => adCounter += 1;
  const currentBreakPoint = useCurrentBreakPoint();
  const numOfItemsBeforeAd = ['XS'].includes(adBreakPoint(currentBreakPoint)) ? 5 : 24;
  const pageStops = [0, ...Object.keys(pages).map(x => +x), items.length];
  const numOfItemsBeforeNativeAd = 7;
  const isSearchTagPage = typeOfList === 'tag' || typeOfList === 'zoek';

  const switchMobileListAd = (itemCounter, isNativeAd) => {
    let adType = itemCounter % 10 ? 'rectangleinterscroller1' : 'rectangleinterscroller2';
    if (isNativeAd) { adType = 'native'; }
    return adType;
  };

  return (
    <>
      {items.map((item, index) => {
        const itemCounter = index + 1;
        const pageTitle = pages[itemCounter];
        const itemCounterPaginated = itemCounter - pageStops[pageStops.findIndex(x => x > index) - 1];
        const isNativeAd = itemCounter === numOfItemsBeforeNativeAd && !isSearchTagPage;

        return (
          <React.Fragment key={`${item.id}-${itemCounter}`}>
            <div>
              <Item
                item={item}
                isToppers={isToppers}
                isSidebar={isSidebar}
                isStoreItem={isStoreItem}
                counter={itemCounterPaginated}
                isModalRelatedItem={isModalRelatedItem}
                isSearchTagPage={isSearchTagPage}
              />
            </div>
            {!hideAds &&
              !isSearchTagPage &&
              itemCounter > 0 &&
              (itemCounter % numOfItemsBeforeAd === 0 || isNativeAd) && (
              <AdWrapper fullWidth={!isNativeAd}>
                {['S', 'M', 'L', 'XL'].includes(adBreakPoint(currentBreakPoint)) && !isNativeAd && (
                  <Ads {...createSlotParams('leaderboard1', `b${(counterIncrement()).toString()}`, true)} />
                )}
                {['XS'].includes(adBreakPoint(currentBreakPoint)) && (
                  <Ads {...createSlotParams(
                    switchMobileListAd(itemCounter, isNativeAd),
                    `b${counterIncrement().toString()}`,
                    ['S', 'M', 'L', 'XL'].includes(adBreakPoint(currentBreakPoint)) && !isNativeAd ? true : false,
                  )} />
                )}
              </AdWrapper>
            )}
            {pageTitle && (
              <div
                className={c(
                  'full',
                  styles.list_bar,
                )}
                style={{ 'paddingTop': '20px' }}>
                <div className={'list_title_holder'}>
                  <h1>{pageTitle}</h1>
                </div>
              </div>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};
